import { render, staticRenderFns } from "./SettingsTableHeaderCell.vue?vue&type=template&id=7af2554f&scoped=true"
import script from "./SettingsTableHeaderCell.vue?vue&type=script&lang=ts"
export * from "./SettingsTableHeaderCell.vue?vue&type=script&lang=ts"
import style0 from "./SettingsTableHeaderCell.vue?vue&type=style&index=0&id=7af2554f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af2554f",
  null
  
)

export default component.exports